import { render } from "./UserComment.vue?vue&type=template&id=2be9e132&scoped=true"
import script from "./UserComment.vue?vue&type=script&lang=js"
export * from "./UserComment.vue?vue&type=script&lang=js"

import "./UserComment.vue?vue&type=style&index=0&id=2be9e132&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-2be9e132"

export default script